<template>
  <div id="app">
    <!-- <div class="bar">
      Zhimeng Yin
    </div> -->
    <div class="bar">
      <div class="icon">
        Zhimeng Yin
      </div>
      <div class="else"></div>
    </div>
    <div class="other" v-if="screenWidth >= 1150">
      <div class="basic">
        <div class="info">
          <div class="head">Zhimeng Yin</div>
          <p>Associate Professor</p>
          <p>Department of Computer Science</p>
          <p>City University of Hong Kong</p>

          <div style="display: flex;align-items: flex-start">
            <div style="display: inline-block;margin-right: 2%">Email:</div>
            <div style="display: inline-block;width: 30%">
              <div>zhimeyin@cityu.edu.hk</div>
              <div>zhimengyin@gmail.com</div>
            </div>
          </div>

          </div>

        <div class="photo">
          <img src="./assets/unnamed.jpg"/>
        </div>    
      </div>
      <div class="interests">
        <div class="head2">Research Interests</div>
        <ul class="a">
          <li>Broad interest in Internet of Things (IoT) and Cyber-Physical Systems (CPS), including
            wireless systems, mobile computing, and IoT security.</li>
          <li>Focused on the intelligent communication, sensing, and localization in IoT systems.</li>
        </ul>
      </div>
      <div class="recruiting">
        <div class="head2">Openings</div>
        <div class="info">
          <div>Recruiting Doctor of Philosophy (multiple positions).</div>
        </div>
      </div>
      <div class="cv">
        <div class="head2">CV</div>
        <div class="cvInfo">
          <div class="left">
            <ul class="a">
              <li>Ph.D. in Dept. of Computer Science & Engineering<br>
              University of Minnesota - Twin Cities (UMN), USA </li><br>
              <li>M.S. in Dept. of Electronics & Information Engineering<br>
              Huazhong University of Science and Technology, China </li><br>
              <li>B.S. in Dept. of Electronics & Information Engineering<br>
              Huazhong University of Science and Technology, China</li><br>
            </ul>
          </div>
          <div class="right">
            <ul class="b">
              <li>Sept. 2014 - Sept. 2020 <br> Advisor: Prof. Tian He </li><br>
              <li>Sept. 2011 - Mar. 2014 <br>  Advisor: Prof. Hongbo Jiang </li><br>
              <li>Sept. 2007 - Jun. 2011 </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="awards">
        <div class="head2">Awards</div>
        <ul class="a">
          <li>NSDI 2026, Outstanding Paper (only 3 recipients).</li>
          <li>MobiCom 2023, Best Community Contribution Award, 2 out of 92 publications.</li>
          <li>MobiCom 2022, Best Community Paper Award, 1 out of 56 publications.</li>
          <li>IEEE Consumer Electronics Magazine 2023, Best Paper Award.</li>
          <li>MSN 2022, Best Paper Award.</li>
        </ul>
      </div>
      <div class="publications">
        <div class="head2">Publications</div>
        <div class="subTitle">
          Conferences
        </div>
        <div class="content">
          <ol class="c">
            <li>[KDD'26] <span style="text-decoration: underline;">Zhaotie Hao</span>, Zhiqing Hong, Jiangyi Fang, Jiawei Ma, Xiangyu Li, Desheng Zhang, Haotian Wang, Tian He, and <b>Zhimeng Yin</b>, "Think Before Action: Learning Suction Health for Reliable Grasp Evaluation in Logistics", proceedings of 2026 ACM SIGKDD International Conference on Knowledge Discovery and Data Mining (KDD) (ACM KDD'26), 2026.
              <a href="https://dl.acm.org/doi/10.1145/3770855.3818492" target="_blank">[PDF]</a></li>
            <li>[NSDI'26] Zhaochen Zhang, Feiyang Xue, Rui Ning, Keqiang He, Gianni Antichi, Jiaqi Gao, <b>Zhimeng Yin</b>, Kexin Liu, Rui Li, Zhengqi Cui, Zhehao Lin, Peirui Cao, Guihai Chen, Chen Tian. "OSCAR: O(1)-Step Convergence And Readily-deployable Congestion Control.".
              <a href="https://www.usenix.org/conference/nsdi26/presentation/zhang-zhaochen" target="_blank">[PDF]</a><b>(Outstanding Paper)</b></li>
            <li>[SMC'25] <span style="text-decoration: underline;">Shuxi Liang</span>, Haolin Ren, Tianze Zhang, Xiaofan Liu, <b>Zhimeng Yin</b>, Daning Hu. "Surveying with AI: Simulating Human Responses Using Personalized LLM Agents and Social Media Data".
              <a href="https://ieeexplore.ieee.org/abstract/document/11343347" target="_blank">[PDF]</a></li>
            <li>[MobiHoc'25] <span style="text-decoration: underline;">Qiling Xu</span>, Binbin Xie, Jie Xiong, Lu Wang, <b>Zhimeng Yin</b>. "InterSen: Boosting LoRa Sensing Capability Under Communication Interference".
              <a href="./pdf/InterSen_MobiHoc25.pdf" target="_blank">[PDF]</a></li>
            <li>[IMWUT'25] <span style="text-decoration: underline;">Naiyu Zheng</span>, Ruofeng Liu, Xiaoyi Fan, Cong Zhang, Lei Zhang, <b>Zhimeng Yin</b>. "SEGALL: A Unified Active Learning Framework for Wireless Sensing Data Segmentation".
              <a href="./pdf/SEGALL_IMWUT25.pdf" target="_blank">[PDF]</a></li>
            <li>[IMWUT'25] <span style="text-decoration: underline;">Qiling Xu</span>, Binbin Xie, Xianjin Xia, Shuai Wang, Lu Wang, <b>Zhimeng Yin</b>. "Combating Chirp Interference for Multi-target LoRa Localization".
              <a href="./pdf/CLoc_IMWUT25.pdf" target="_blank">[PDF]</a></li>
            <li>[EuroSys'25] Zhaochen Zhang, Feiyang Xue, Keqiang He, <b>Zhimeng Yin</b>, Gianni Antichi, Jiaqi Gao, Yizhi Wang, Rui Ning, Haixin Nan, Xu Zhang, Peirui Cao, Xiaoliang Wang, Wanchun Dou, Guihai Chen, Chen Tian. "Enabling Virtual Priority in Data Center Congestion Control".
              <a href="https://dl.acm.org/doi/abs/10.1145/3689031.3717463" target="_blank">[PDF]</a><b>(Best Student Paper)</b></li>
            <li>[IMWUT'25] <span style="text-decoration: underline;">Kai Sun</span>, Shuai Wang, Renjie Zhao, Ruofeng Liu, Weiwei Chen, <b>Zhimeng Yin</b>, Wei Gong, Shuai Wang. "Wuloc: Achieving extremely long-range high-precision localization via wi-fi-uwb connection".
              <a href="https://dl.acm.org/doi/abs/10.1145/3712282" target="_blank">[PDF]</a></li>
            <li>[Mobicom'25] <span style="text-decoration: underline;">Danei Gong</span>, <span style="text-decoration: underline;">Naiyu Zheng</span>, Binbin Xie, Jie Xiong, Shuai Wang, Yuguang Fang, <b>Zhimeng Yin</b>. "SeRadar: Embracing Secondary Reflections for Human Sensing with mmWave Radar".
              <a href="https://dl.acm.org/doi/10.1145/3680207.3723471" target="_blank">[PDF]</a></li>
            <li>[IMWUT/Ubicomp'24] <span style="text-decoration: underline;">Luoyu Mei</span>, Ruofeng Liu, <b>Zhimeng Yin</b>, Qingchuan Zhao, Wenchao Jiang, Shuai Wang, Shuai Wang, Kangjie Lu, Tian He. "mmSpyVR: Exploiting mmWave Radar for Penetrating Obstacles to Uncover Privacy Vulnerability of Virtual Reality",
                in proceedings of the ACM on Interactive, Mobile, Wearable and Ubiquitous Technologies.<a href="./pdf/mmSpyVR_IMWUT24.pdf" target="_blank">[PDF]</a></li>
            <li>[SenSys'24] Ruofeng Liu, Tianshun Yao, Ruili Shi, <span style="text-decoration: underline;">Luoyu Mei</span>, Shuai Wang, <b>Zhimeng Yin</b>, Wenchao Jiang, Shuai Wang. "Mission: mmWave Radar Person Identification with RGB Cameras",
              in proceedings of the 22nd ACM Conference on Embedded Networked Sensor Systems.<a href="https://dl.acm.org/doi/abs/10.1145/3666025.3699340" target="_blank">[PDF]</a></li>
            <li>[IJCAI'24] <span style="text-decoration: underline;">Luoyu Mei</span>, Shuai Wang, Yun Cheng, Ruofeng Liu, <b>Zhimeng Yin</b>, Wenchao Jiang, Wei Gong. "ESP-PCT: Enhanced VR Semantic Performance through Efficient Compression of Temporal and Spatial Redundancies in Point Cloud Transformers",
              in proceedings of the International Joint Conferences on Artificial Intelligence.<a href="https://arxiv.org/abs/2409.01216" target="_blank">[PDF]</a></li>
            <li>[MobiCom'24] <span style="text-decoration: underline;">Xiubin Fan</span>, Guanyao Li, Zhongming Lin, Yuming Hu, Liu Yang, Tianrui Jiang, <b>Zhimeng Yin</b>, Feng Qian, Shuai Wang, and S.-H. Gary Chan. "Experiences of Deploying a Citywide Crowdsourcing Platform for Searching Missing People with Dementia",
              in proceedings of the 30th Annual International Conference on Mobile Computing and Networking.<a href="./pdf/Dementia_MobiCom24.pdf" target="_blank">[PDF]</a></li>
            <li>[NSDI'24] <span style="text-decoration: underline;">Xiubin Fan</span>, Zhongming Lin, Yuming Hu, Tianrui Jiang, Feng Qian, <b>Zhimeng Yin</b>, S.-H. Gary Chan, Dapeng Wu, "Passenger's Safety Matters: Experiences of Deploying a Large-Scale Indoor Delivery Monitoring System",
              21st USENIX Symposium on Networked Systems Design and Implementation.<a href="https://www.usenix.org/conference/nsdi24/presentation/fan" target="_blank">[PDF]</a></li>
              <li>[ICNP'23] <span style="text-decoration: underline;">Qiling Xu</span>, <span style="text-decoration: underline;">Kai Sun</span>, Shuai Wang, Pengpeng Chen, <b>Zhimeng Yin</b>,  "SLoRa: A Systematic Framework for Synergic Interference Resilience In LPWAN",
                IEEE 31st International Conference on Network Protocols.<a href="./pdf/SLoRa_ICNP23.pdf" target="_blank">[PDF]</a></li>
              <li>[MobiCom'23] Yuming Hu, <span style="text-decoration: underline;">Xiubin Fan</span>, <b>Zhimeng Yin</b>, Feng Qian, Zhe Ji, Yuanchao Shu, Yeqiang Han, Qiang Xu, Jie Liu, Victor Bahl, "The Wisdom of 1,100 Teams: Lessons and Experiences from a Large Indoor Localization Competition",
              in proceedings of the 29th Annual International Conference on Mobile Computing and Networking.<a href="./pdf/IndoorLoc_MobiCom23.pdf" target="_blank">[PDF]</a><b>(Best Community Contribution Award)</b></li>
              <li>[MobiCom'22] Yuming Hu, Feng Qian, <b>Zhimeng Yin</b>, Zhenhua Li, Zhe Ji, Yeqiang Han, Qiang Xu, and Wei Jiang, "Experience:Practical Indoor Localization for Malls",
              in proceedings of the 28th Annual International Conference on Mobile Computing and Networking.<a href="https://dl.acm.org/doi/10.1145/3495243.3517021" target="_blank">[PDF]</a><b>(Best Community Paper Award)</b></li>
              <li>[ICNP'22] Zhuqing Xu, Junzhou Luo, <b>Zhimeng Yin</b>, Shuai Wang, <span style="text-decoration: underline;">Ciyuan Chen</span>, Jingkai Lin, Runqun Xiong, Tian He, "X-MAC: Achieving High Scalability via Imperfect-Orthogonality Aware Scheduling in LPWAN",
                in Proc. of the IEEE 30th International Conference on Network Protocols.<a href="./pdf/XMAC_ICNP22.pdf" target="_blank">[PDF]</a></li>
              <li>[MobiCom'21] Ruofeng Liu, <b>Zhimeng Yin</b>, Wenchao Jiang, and Tian He, "WiBeacon: expanding BLE location-based services via wifi.",
                 in proceedings of the 27th Annual International Conference on Mobile Computing and Networking.<a href="https://dl.acm.org/doi/10.1145/3447993.3448615" target="_blank">[PDF]</a></li>
              <li>[SenSys'21] Shangyao Yan, <b>Zhimeng Yin</b>, and Guang Tang, "CurveLight:An Accurate and Practical Light Positioning System",
                 in Proc. of the 17th Conference on Embedded Network Sensor Systems.<a href="https://dl.acm.org/doi/10.1145/3485730.3485934" target="_blank">[PDF]</a></li>
              <li>[ICNP'21] <span style="text-decoration: underline;">Kai Sun</span>, <b>Zhimeng Yin</b>,  Weiwei Chen, Shuai Wang, Zeyu Zhang, and Tian He, "Partial Symbol Recovery for Interference Resilience in Low-Power Wide Area Networks",
                in Proc. of the 29th International Conference on Network Protocols.<a href="https://ieeexplore.ieee.org/document/9651936" target="_blank">[PDF]</a></li>
              <li>[ICNP'20] <span style="text-decoration: underline;">Bin Hu</span>, <b>Zhimeng Yin</b>, Shuai Wang, Zhuqing Xu, and Tian He, "SCLoRa: Leveraging Multi-Dimensionality in Decoding Collided LoRa Transmissions",
                in Proc. of the 28th International Conference on Network Protocols.<a href="https://ieeexplore.ieee.org/document/9259397" target="_blank">[PDF]</a></li>
              <li>[ICNP'20] Ruofeng Liu; <b>Zhimeng Yin</b>; Wenchao Jiang; and Tian He, "XFi: Cross-technology IoT Data Collection via Commodity WiFi",
                in Proc. of the 28th International Conference on Network Protocols.<a href="https://ieeexplore.ieee.org/document/9259363" target="_blank">[PDF]</a></li>
              <li>[ICDCS'20] <b>Zhimeng Yin</b>, Wenchao Jiang, Ruofeng Liu, Song Min Kim, and Tian He, "SafetyNet: Interference Protection via Transparent PHY Layer Coding", 
                accepted by 40th IEEE International Conference on Distributed Computing Systems.<a href="https://ieeexplore.ieee.org/document/9355809" target="_blank">[PDF]</a></li>
              <li>[INFOCOM'20] Zhuqing Xu, Junzhou Luo, <b>Zhimeng Yin</b>, Tian He, and Fang Dong, "S-MAC: Achieving High Scalability via Adaptive Scheduling in LPWAN", 
                in Proc. of the IEEE International Conference on Computer Communications.<a href="https://ieeexplore.ieee.org/document/9155474" target="_blank">[PDF]</a></li>
              <li>[INFOCOM'20] Weiwei Chen, <b>Zhimeng Yin</b> and Tian He, "Global Cooperation for Heterogeneous Networks", 
                in Proc. of the IEEE International Conference on Computer Communications.<a href="https://ieeexplore.ieee.org/document/9155453" target="_blank">[PDF]</a></li>
              <li>[SenSys'19] Ruofeng Liu, <b>Zhimeng Yin</b>, Wenchao Jiang, and Tian He, "LTE2B: Time-Domain Cross-Technology Emulation under LTE Constraints", 
                in Proc. of the 15th Conference on Embedded Network Sensor Systems.<a href="https://www.youtube.com/watch?v=ycOY9y__3bw" target="_blank">[DEMO]</a> <a href="https://drive.google.com/open?id=1YpToX-A5ObZi2xJMcViPcRtx3J21HXhi" target="_blank">[PDF]</a></li>
              <li>[ICNP'18] Shuai Wang, <b>Zhimeng Yin</b>, Zhijun Li, and Tian He, "Networking Support For Physical-Layer Cross-Technology Communication", 
                in Proc. of the 26th International Conference on Network Protocols.<a href="https://drive.google.com/open?id=10lJS-KC6DKc8JQIHiBv2gZq-RGYXZs9f" target="_blank">[PDF]</a></li>
              <li>[MobiSys'18] <b>Zhimeng Yin</b>, Zhijun Li, Song Min Kim, and Tian He, "Explicit Channel Coordination via Cross-technology Communication",
                in proceedings of 16th Annual International Conference on Mobile Systems, Applications, and Services.<a href="https://drive.google.com/open?id=1RByIdZSEoTK78UzfN8lWLzozZXDKdXTs" target="_blank">[PDF]</a></li>
              <li>[INFOCOM'17] <b>Zhimeng Yin</b>, Wenchao Jiang, Song Min Kim and Tian He, "C-Morse: Cross-technology communication with transparent Morse coding",
                in Proc. of the IEEE International Conference on Computer Communications.<a href="https://drive.google.com/open?id=1WcCAkuzyttSE6Lvp5bljeQPSM2Vjubwi" target="_blank">[PDF]</a></li>
              <li>[SenSys'17] Wenchao Jiang, <b>Zhimeng Yin</b>, Ruofeng Liu, Zhijun Li, Song Min Kim, and Tian He, "BlueBee: a 10, 000x Faster Cross-Technology Communication via PHY Emulation", 
                in Proc. of the 13th Conference on Embedded Network Sensor Systems.<a href="https://youtu.be/ZAtHBLRmEUs" target="_blank">[DEMO]</a> <a href="https://drive.google.com/open?id=1CxFDggwstEQVg81AMC-VYEF8v-X2Tanr" target="_blank">[PDF]</a></li>
              <li>[INFOCOM'17] Wenchao Jiang, <b>Zhimeng Yin</b>, Song Min Kim, and Tian He, "Transparent Cross-technology Communication over Data Traffic", 
                in Proc. of the IEEE International Conference on Computer Communications.<a href="https://drive.google.com/open?id=1cAvJAVZAXXz80_jEZkDIMsQgby4tth5h" target="_blank">[PDF]</a></li>
              <li>[ICNP'14] Shuai Wang, Song Min Kim, <b>Zhimeng Yin</b>, and Tian He,"Correlated Coding: Efficient Network Coding under Correlated Unreliable Wireless Links", 
                in Proc. of the 22nd International Conference on Network Protocols.<a href="https://drive.google.com/open?id=1Vtoev5SvDapNdgj0aG4OTU00pI2ki9UN" target="_blank">[PDF]</a></li>
              <li>[SIGMETRICS'13] Guang Tan, <b>Zhimeng Yin</b>, and Hongbo Jiang, "Trap array: a unified model for scalability evaluation of geometric routing", In ACM SIGMETRICS'13.<a href="https://drive.google.com/open?id=1rvgkNtoTgUhpQAOl6LV8cUIcuMy1xqiu" target="_blank">[PDF]</a></li>
          </ol>
        </div>
        <div class="subTitle">
          Journals
        </div>
        <div class="content">
           <ol class="c">
            <li>[TOSN] Shuai Wang, <span style="text-decoration: underline;">Luoyu Mei</span>, <b>Zhimeng Yin</b>, Hao Li, Ruofeng Liu, Wenchao Jiang, Chris Xiaoxuan Lu. "End-to-End Target Liveness Detection via mmWave Radar and Vision Fusion for Autonomous Vehicles".
              <a href="./pdf/mmLD_LivenessDetection.pdf" target="_blank">[PDF]</a></li>
            <li>[TMC] Zhuqing Xu, Junzhou Luo, <b>Zhimeng Yin</b>, Shuai Wang, <span style="text-decoration: underline;">Ciyuan Chen</span>, Jingkai Lin, Runqun Xiong, Tian He. "Leveraging Imperfect-Orthogonality Aware Scheduling for High Scalability in LPWAN".
              <a href="./pdf/IOAS_TMC.pdf" target="_blank">[PDF]</a></li>
            <li>[TMC] <span style="text-decoration: underline;">Luoyu Mei</span>, Shuai Wang, Ruofeng Liu, Yun Cheng, Wenchao Jiang, <b>Zhimeng Yin</b>, Tian He. "VR-PCT: Enhanced VR Semantic Performance via Edge-Client Collaborative Multi-modal Point Cloud Transformers".
              <a href="./pdf/VRPCT_TMC.pdf" target="_blank">[PDF]</a></li>
            <li>[TMC] <span style="text-decoration: underline;">Xiubin Fan</span>, Zhongming Lin, Yuming Hu, Zhiqing Hong, Tianrui Jiang, Feng Qian, <b>Zhimeng Yin</b>, S-H Gary Chan, Dapeng Oliver Wu. "DeMo: Experiences of Deploying a Large-Scale Indoor Delivery Monitoring System".
              <a href="./pdf/DeMo_TMC.pdf" target="_blank">[PDF]</a></li>
            <li>[TMC] <span style="text-decoration: underline;">Weizheng Wang</span>, Dusit Niyato, Zehui Xiong, <b>Zhimeng Yin</b>. "AUTHFi: Cross-technology device authentication via commodity WiFi".
              <a href="./pdf/AUTHFi_TMC.pdf" target="_blank">[PDF]</a></li>
            <li>[TMC] Yuhan Lin, Haoran Xu, <b>Zhimeng Yin</b>, Guang Tan. "Edge assisted low-latency cooperative BEV perception with progressive state estimation".
              <a href="https://ieeexplore.ieee.org/abstract/document/10772318" target="_blank">[PDF]</a></li>
            <li>[TOSN] <span style="text-decoration: underline;">Qiling Xu</span>, <span style="text-decoration: underline;">Danei Gong</span>, <span style="text-decoration: underline;">Kai Sun</span>, Shuai Wang, Pengpeng Chen, Binbin Xie, <b>Zhimeng Yin</b>. "SLoRa+: A Systematic Framework for Enhanced Interference Resilience in LoRaWAN".
              <a href="./pdf/SLoRaPlus_TOSN.pdf" target="_blank">[PDF]</a></li>
            <li>[CN] <span style="text-decoration: underline;">Kai Sun</span>, <span style="text-decoration: underline;">Bin Hu</span>, <b>Zhimeng Yin</b>, Shuai Wang, Zhuqing Xu, Tian He. "Joint multidimensional features for LoRa reception in burst traffic".
              <a href="https://www.sciencedirect.com/science/article/pii/S1389128625004438" target="_blank">[PDF]</a></li>
            <li>[TMC] <span style="text-decoration: underline;">Naiyu Zheng</span>, Yuanchun Li, Shiqi Jiang, Yuanzhe Li, Rongchun Yao, Chuchu Dong, Ting Chen, Yubo Yang, <b>Zhimeng Yin</b>, Yunxin Liu, "AdaWiFi, Collaborative WiFi Sensing for Cross-Environment Adaptation", 
                in IEEE Transactions on Mobile Computing.<a href="https://ieeexplore.ieee.org/abstract/document/10715589/" target="_blank">[PDF]</a></li>
            <li>[CN] <span style="text-decoration: underline;">Ciyuan Chen</span>, Junzhou Luo, Zhuqing Xu, Runqun Xiong, Dian Shen, <b>Zhimeng Yin</b>, "Enabling large-scale low-power LoRa data transmission via multiple mobile LoRa gateways", 
                in Computer Networks.<a href="https://www.sciencedirect.com/science/article/pii/S1389128623005285" target="_blank">[PDF]</a></li>
              <li>[CEM] <span style="text-decoration: underline;">Weizheng Wang</span>, Fida Hussain Memon, Zhuotao Lian, <b>Zhimeng Yin</b>, Thippa Reddy Gadekallu, Quoc-Viet Pham, Kapal Dev, Chunhua Su, "Secure-Enhanced Federated Learning for AI-Empowered Electric Vehicle Energy Prediction", 
                in IEEE Consumer Electronics Magazine.<a href="https://ieeexplore.ieee.org/abstract/document/9555212" target="_blank">[PDF]</a></li>
              <li>[DCN] <span style="text-decoration: underline;">Weizheng Wang</span>, Huakun Huang, <b>Zhimeng Yin</b>, Thippa Reddy Gadekallu, Mamoun Alazab, Chunhua Su, "Smart contract token-based privacy-preserving access control system for industrial Internet of Things", 
                in Digital Communications and Networks.<a href="https://www.sciencedirect.com/science/article/pii/S2352864822002140" target="_blank">[PDF]</a></li>
              <li>[JSAC] <span style="text-decoration: underline;">Weizheng Wang</span>, Yaoqi Yang, <b>Zhimeng Yin</b>, Kapal Dev, Xiaokang Zhou, Xingwang Li, Nawab Muhammad Faseeh Qureshi, Chunhua Su, "BSIF: Blockchain-Based Secure, Interactive, and Fair Mobile Crowdsensing", 
                in IEEE Journal on Selected Areas in Communications.<a href="https://ieeexplore.ieee.org/abstract/document/9921212" target="_blank">[PDF]</a></li>
              <li>[IOT] <span style="text-decoration: underline;">Weizheng Wang</span>, Qiu Chen, <b>Zhimeng Yin</b>, Gautam Srivastava, Thippa Reddy Gadekallu, Fawaz Alsolami, Chunhua Su, "Blockchain and PUF-based lightweight authentication protocol for wireless medical sensor networks", 
                in IEEE Internet of Things Journal.<a href="https://ieeexplore.ieee.org/abstract/document/9559388" target="_blank">[PDF]</a></li>  
              <li>[TMC] Shuai Wang, <b>Zhimeng Yin</b>, Shuai Wang, Yongrui Chen, Zhijun Li, Song Min Kim, and Tian He, "Networking Support for Bidirectional Cross-technology Communication", 
                in the ACM Transactions on Mobile Computing.<a href="https://drive.google.com/open?id=1ZNxFwbUvGzFn3xNLFDEWsYF9BcpDGFNl" target="_blank">[PDF]</a></li>
              <li>[TON] Wenchao Jiang,<b> Zhimeng Yin</b>, Ruofeng Liu, Zhijun Li, Song Min Kim, and Tian He, "Boosting the Bitrate of Cross-Technology Communication on Commodity IoT Devices", 
                in the ACM/IEEE Transactions on Networking.<a href="https://drive.google.com/open?id=1oK5KF09qTre71BMFi_WtyifMXGKtzR0S" target="_blank">[PDF]</a></li>
              <li>[TON] Guang Tan, <b>Zhimeng Yin</b>, and Hongbo Jiang, "Trap Array: A Unified Model for Scalability Evaluation of Geometric Routing", 
                in the ACM/IEEE Transactions on Networking.<a href="https://drive.google.com/open?id=1L21ERP-1EgakU3GRfhPODdBbBVM3P7gz" target="_blank">[PDF]</a></li>
              <li>[TWC] Kechao Cai, <b>Zhimeng Yin</b>, Hongbo Jiang, Guang Tan, Peng Guo, Chonggang Wang, and Bo Li, "OnionMap: A Scalable Geometric Addressing and Routing Scheme for 3D Sensor Networks", 
                In IEEE Transactions on Wireless Communications.<a href="https://drive.google.com/open?id=1rfbfLE-o0wfsja_Q3kvWRr1p-hzaxT0D" target="_blank">[PDF]</a></li>
              <li>[TOSN] Shuai Wang, Song Min Kim, <b>Zhimeng Yin</b>, and Tian He, "Encode When Necessary: Correlated Network Coding Under Unreliable Wireless Links," 
                in the ACM Transactions on Sensor Networks.<a href="https://drive.google.com/open?id=1YciMa0ELFkdsV0kQLuUHVkZY0Z3oNwrb" target="_blank">[PDF]</a></li>
              <li>[TOSN] Guang Tan, Hongbo Jiang, Shengkai Zhang, <b>Zhimeng Yin</b>, Anne-Marie Kermarrec, "Connectivity-based and anchor-free localization in large-scale 2D/3D sensor networks", 
                in the ACM Transactions on Sensor Networks.<a href="https://drive.google.com/open?id=1QYTNNLqACyZDWgiJYCP0hC9beB1OVvcF" target="_blank">[PDF]</a></li>
          </ol> 
        </div>
      </div>

      <!-- Alumni 大栏（大屏） -->
      <div class="alumni">
        <div class="head2">Alumni</div>
        <ul class="a">
          <li>
            <a href="https://staff.uic.edu.cn/xiubinfan/en" target="_blank">Dr. Xiubin Fan</a>
            (PhD Student, Sep 2021–Jun 2025), Assistant Professor at Beijing Normal–Hong Kong Baptist University.
          </li>
          <li>
            <span>Dr. Weizheng Wang</span>
            (PhD Student, Sep 2021–Apr 2025), Professor at Guangzhou University.
          </li>
        </ul>
      </div>

      <div class="demo">
        <div class="head2">BlueBee Demo</div>
        <div class="show">
           <div class="vedios">
                <iframe width="562" height="316" 
                src="https://www.youtube.com/embed/ZAtHBLRmEUs" frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen></iframe>
           </div>
           <div class="description">
              The cross-technology communication (CTC) is a promising technique proposed recently to bridge heterogeneous wireless technologies in the ISM bands. 
              Existing solutions use only the coarse-grained packet-level information for CTC modulation, suffering from a low throughput (e.g., 10 b/s). 
              BlueBee explores the PHY-layer information for CTC by emulating legitimate ZigBee frames with the Bluetooth radio, achieving dual-standard compliance and transparency. 
              Our implementation on both USRP and commodity devices shows that BlueBee can achieve standard ZigBee bit rate of 250 kb/s at more than 99% accuracy, 
              10000x faster than the start-of-the-art packet-level CTC technologies. 
           </div>
        </div>
        <div class="head2">LTE2B Demo</div>
        <div class="show">
          <div class="vedios">
                <iframe width="562" height="316" 
                src="https://www.youtube.com/embed/ycOY9y__3bw" frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen></iframe>
           </div>
           <div class="description">
              LTE2B enables WAN/WLAN devices, e.g., LTE smartphones and WiFi Access Points, 
              to directly transmit data to low-power IoT devices such as ZigBee and Bluetooth. 
              This is achieved via Time-domain Emulation that enables WAN/WLAN transmitters to accurately emulate the ZigBee/Bluetooth waveform. 
              We implement LTE2B on commodity devices (Nexus 5X smartphone and CC2530/CC1350 ZigBee/BLE SoC). 
              Extensive evaluation demonstrates that LTE2B achieves a robust (> 99% accuracy) and long distance (> 400 m) CTC performance under a full range of wireless configurations including indoor/outdoor, mobility, and duty-cycle settings. 
           </div>
        </div>
      </div>
      <div class="acitivities">

        <div class="head2">Professional Acitivities</div>
        <div class="subTitle">
          Journal Editors and Conference Organization Committee
        </div>
        <div class="content">
          <ul class="c">
            <li>ACM Transactions on Internet of Things, Associate Editor.</li>
            <li>IEEE Wireless Communications Letters, Associate Editor.</li>
            <li>ACM MobiSys 2025, Student Travel Grant Chair.</li>
            <li>IEEE ICPADS 2021, Publication Chair.</li>
          </ul>
        </div>
        <div class="subTitle">
          Recent TPC activities
        </div>
        <div class="content">
          <ul class="c">
            <li>SenSys 2026&amp;2027</li>
            <li>MobiCom 2027</li>
            <li>MSN 2025</li>
            <li>ICDCS 2025&amp;2021</li>
            <li>BuildSys 2025</li>
            <li>EWSN 2025</li>
            <li>IMWUT 2025&amp;2024</li>
            <li>VTC 2024</li>
            <li>IoTDI 2024</li>
            <li>HPCC 2024</li>
            <li>VTC 2024&amp;2023</li>
            <li>Smart City 2022</li>
          </ul>
        </div>
        <div class="subTitle">
          Reviewer
        </div>
        <div class="content">
          <ul class="c">
            <li>IEEE/ACM Transactions on Networking</li>
            <li>IEEE Transactions on Mobile Computing</li>
            <li>ACM Transactions on Sensor Networks</li>
            <li>ACM Transactions on Internet of Things</li>
            <li>IEEE Journal on Selected Areas in Communications</li>
            <li>Computer Networks</li>
            <li>IEEE Journal on Selected Areas in Communications</li>
          </ul>
        </div>
      </div>
      <div class="bottom"></div>
    </div>

    <!-- 小屏布局 -->
    <div class="otherSmall" v-else>
      <div class="basic">
        <div class="info">
          <div class="head">Zhimeng Yin</div>
          <p>Associate Professor</p>
          <p>Department of Computer Science</p>
          <p>City University of Hong Kong</p>
          <div style="display: flex;align-items: flex-start">
            <div style="display: inline-block;margin-right: 2%">Email:</div>
            <div style="display: inline-block;width: 30%">
              <div>zhimeyin@cityu.edu.hk</div>
              <div>zhimengyin@gmail.com</div>
            </div>
          </div>
        </div>
        <div class="photo">
          <img src="./assets/unnamed.jpg"/>
        </div>    
      </div>
      <div class="interests">
        <div class="head2">Research Interests</div>
        <ul class="a">
          <li>Broad interest in Internet of Things (IoT) and Cyber-Physical Systems (CPS), including
            wireless systems, mobile computing, and IoT security.</li>
          <li>Focused on the intelligent communication, sensing, and localization in IoT systems.</li>
        </ul>
      </div>
      <div class="recruiting">
        <div class="head2">Openings</div>
        <div class="info">
          <div>Recruiting Doctor of Philosophy (multiple positions).</div>
        </div>
      </div>
      <div class="cv">
        <div class="head2">CV</div>
        <div class="cvInfo">
          <div class="left">
            <ul class="a">
              <li>Ph.D. in Dept. of Computer Science & Engineering<br>
              University of Minnesota - Twin Cities (UMN), USA </li><br>
              <li>M.S. in Dept. of Electronics & Information Engineering<br>
              Huazhong University of Science and Technology, China </li><br>
              <li>B.S. in Dept. of Electronics & Information Engineering<br>
              Huazhong University of Science and Technology, China</li><br>
            </ul>
          </div>
          <div class="right">
            <ul class="b">
              <li>Sept. 2014 - Sept. 2020 <br> Advisor: Prof. Tian He </li><br>
              <li>Sept. 2011 - Mar. 2014 <br>  Advisor: Prof. Hongbo Jiang </li><br>
              <li>Sept. 2007 - Jun. 2011 </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="awards">
        <div class="head2">Awards</div>
        <ul class="a">
          <li>NSDI 2026, Outstanding Paper (only 3 recipients).</li>
          <li>MobiCom 2023, Best Community Contribution Award, 2 out of 92 publications.</li>
          <li>MobiCom 2022, Best Community Paper Award, 1 out of 56 publications.</li>
          <li>IEEE Consumer Electronics Magazine 2023, Best Paper Award.</li>
          <li>MSN 2022, Best Paper Award.</li>
        </ul>
      </div>
      <div class="publications">
        <div class="head2">Publications</div>
        <div class="subTitle">
          Conferences
        </div>
        <div class="content">
          <ol class="c">
            <li>[KDD'26] <span style="text-decoration: underline;">Zhaotie Hao</span>, Zhiqing Hong, Jiangyi Fang, Jiawei Ma, Xiangyu Li, Desheng Zhang, Haotian Wang, Tian He, and <b>Zhimeng Yin</b>, "Think Before Action: Learning Suction Health for Reliable Grasp Evaluation in Logistics", proceedings of 2026 ACM SIGKDD International Conference on Knowledge Discovery and Data Mining (KDD) (ACM KDD'26), 2026.
              <a href="https://dl.acm.org/doi/10.1145/3770855.3818492" target="_blank">[PDF]</a></li>
            <li>[NSDI'26] Zhaochen Zhang, Feiyang Xue, Rui Ning, Keqiang He, Gianni Antichi, Jiaqi Gao, <b>Zhimeng Yin</b>, Kexin Liu, Rui Li, Zhengqi Cui, Zhehao Lin, Peirui Cao, Guihai Chen, Chen Tian. "OSCAR: O(1)-Step Convergence And Readily-deployable Congestion Control.".
              <a href="https://www.usenix.org/conference/nsdi26/presentation/zhang-zhaochen" target="_blank">[PDF]</a><b>(Outstanding Paper)</b></li>
            <li>[SMC'25] <span style="text-decoration: underline;">Shuxi Liang</span>, Haolin Ren, Tianze Zhang, Xiaofan Liu, <b>Zhimeng Yin</b>, Daning Hu. "Surveying with AI: Simulating Human Responses Using Personalized LLM Agents and Social Media Data".
              <a href="https://ieeexplore.ieee.org/abstract/document/11343347" target="_blank">[PDF]</a></li>
            <li>[MobiHoc'25] <span style="text-decoration: underline;">Qiling Xu</span>, Binbin Xie, Jie Xiong, Lu Wang, <b>Zhimeng Yin</b>. "InterSen: Boosting LoRa Sensing Capability Under Communication Interference".
              <a href="./pdf/InterSen_MobiHoc25.pdf" target="_blank">[PDF]</a></li>
            <li>[IMWUT'25] <span style="text-decoration: underline;">Naiyu Zheng</span>, Ruofeng Liu, Xiaoyi Fan, Cong Zhang, Lei Zhang, <b>Zhimeng Yin</b>. "SEGALL: A Unified Active Learning Framework for Wireless Sensing Data Segmentation".
              <a href="./pdf/SEGALL_IMWUT25.pdf" target="_blank">[PDF]</a></li>
            <li>[IMWUT'25] <span style="text-decoration: underline;">Qiling Xu</span>, Binbin Xie, Xianjin Xia, Shuai Wang, Lu Wang, <b>Zhimeng Yin</b>. "Combating Chirp Interference for Multi-target LoRa Localization".
              <a href="./pdf/CLoc_IMWUT25.pdf" target="_blank">[PDF]</a></li>
            <li>[EuroSys'25] Zhaochen Zhang, Feiyang Xue, Keqiang He, <b>Zhimeng Yin</b>, Gianni Antichi, Jiaqi Gao, Yizhi Wang, Rui Ning, Haixin Nan, Xu Zhang, Peirui Cao, Xiaoliang Wang, Wanchun Dou, Guihai Chen, Chen Tian. "Enabling Virtual Priority in Data Center Congestion Control".
              <a href="https://dl.acm.org/doi/abs/10.1145/3689031.3717463" target="_blank">[PDF]</a><b>(Best Student Paper)</b></li>
            <li>[IMWUT'25] <span style="text-decoration: underline;">Kai Sun</span>, Shuai Wang, Renjie Zhao, Ruofeng Liu, Weiwei Chen, <b>Zhimeng Yin</b>, Wei Gong, Shuai Wang. "Wuloc: Achieving extremely long-range high-precision localization via wi-fi-uwb connection".
              <a href="https://dl.acm.org/doi/abs/10.1145/3712282" target="_blank">[PDF]</a></li>
            <li>[Mobicom'25] <span style="text-decoration: underline;">Danei Gong</span>, <span style="text-decoration: underline;">Naiyu Zheng</span>, Binbin Xie, Jie Xiong, Shuai Wang, Yuguang Fang, <b>Zhimeng Yin</b>. "SeRadar: Embracing Secondary Reflections for Human Sensing with mmWave Radar".
              <a href="https://dl.acm.org/doi/10.1145/3680207.3723471" target="_blank">[PDF]</a></li>
            <li>[IMWUT/Ubicomp'24] <span style="text-decoration: underline;">Luoyu Mei</span>, Ruofeng Liu, <b>Zhimeng Yin</b>, Qingchuan Zhao, Wenchao Jiang, Shuai Wang, Shuai Wang, Kangjie Lu, Tian He. "mmSpyVR: Exploiting mmWave Radar for Penetrating Obstacles to Uncover Privacy Vulnerability of Virtual Reality",
                in proceedings of the ACM on Interactive, Mobile, Wearable and Ubiquitous Technologies.<a href="./pdf/mmSpyVR_IMWUT24.pdf" target="_blank">[PDF]</a></li>
            <li>[SenSys'24] Ruofeng Liu, Tianshun Yao, Ruili Shi, <span style="text-decoration: underline;">Luoyu Mei</span>, Shuai Wang, <b>Zhimeng Yin</b>, Wenchao Jiang, Shuai Wang. "Mission: mmWave Radar Person Identification with RGB Cameras",
              in proceedings of the 22nd ACM Conference on Embedded Networked Sensor Systems.<a href="https://dl.acm.org/doi/abs/10.1145/3666025.3699340" target="_blank">[PDF]</a></li>
            <li>[IJCAI'24] <span style="text-decoration: underline;">Luoyu Mei</span>, Shuai Wang, Yun Cheng, Ruofeng Liu, <b>Zhimeng Yin</b>, Wenchao Jiang, Wei Gong. "ESP-PCT: Enhanced VR Semantic Performance through Efficient Compression of Temporal and Spatial Redundancies in Point Cloud Transformers",
              in proceedings of the International Joint Conferences on Artificial Intelligence.<a href="https://arxiv.org/abs/2409.01216" target="_blank">[PDF]</a></li>
            <li>[MobiCom'24] <span style="text-decoration: underline;">Xiubin Fan</span>, Guanyao Li, Zhongming Lin, Yuming Hu, Liu Yang, Tianrui Jiang, <b>Zhimeng Yin</b>, Feng Qian, Shuai Wang, and S.-H. Gary Chan. "Experiences of Deploying a Citywide Crowdsourcing Platform for Searching Missing People with Dementia",
              in proceedings of the 30th Annual International Conference on Mobile Computing and Networking.<a href="./pdf/Dementia_MobiCom24.pdf" target="_blank">[PDF]</a></li>
            <li>[NSDI'24] <span style="text-decoration: underline;">Xiubin Fan</span>, Zhongming Lin, Yuming Hu, Tianrui Jiang, Feng Qian, <b>Zhimeng Yin</b>, S.-H. Gary Chan, Dapeng Wu, "Passenger's Safety Matters: Experiences of Deploying a Large-Scale Indoor Delivery Monitoring System",
              21st USENIX Symposium on Networked Systems Design and Implementation.<a href="https://www.usenix.org/conference/nsdi24/presentation/fan" target="_blank">[PDF]</a></li>
              <li>[ICNP'23] <span style="text-decoration: underline;">Qiling Xu</span>, <span style="text-decoration: underline;">Kai Sun</span>, Shuai Wang, Pengpeng Chen, <b>Zhimeng Yin</b>,  "SLoRa: A Systematic Framework for Synergic Interference Resilience In LPWAN",
                IEEE 31st International Conference on Network Protocols.<a href="./pdf/SLoRa_ICNP23.pdf" target="_blank">[PDF]</a></li>
              <li>[MobiCom'23] Yuming Hu, <span style="text-decoration: underline;">Xiubin Fan</span>, <b>Zhimeng Yin</b>, Feng Qian, Zhe Ji, Yuanchao Shu, Yeqiang Han, Qiang Xu, Jie Liu, Victor Bahl, "The Wisdom of 1,100 Teams: Lessons and Experiences from a Large Indoor Localization Competition",
              in proceedings of the 29th Annual International Conference on Mobile Computing and Networking.<a href="./pdf/IndoorLoc_MobiCom23.pdf" target="_blank">[PDF]</a><b>(Best Community Contribution Award)</b></li>
              <li>[MobiCom'22] Yuming Hu, Feng Qian, <b>Zhimeng Yin</b>, Zhenhua Li, Zhe Ji, Yeqiang Han, Qiang Xu, and Wei Jiang, "Experience:Practical Indoor Localization for Malls",
              in proceedings of the 28th Annual International Conference on Mobile Computing and Networking.<a href="https://dl.acm.org/doi/10.1145/3495243.3517021" target="_blank">[PDF]</a><b>(Best Community Paper Award)</b></li>
              <li>[ICNP'22] Zhuqing Xu, Junzhou Luo, <b>Zhimeng Yin</b>, Shuai Wang, <span style="text-decoration: underline;">Ciyuan Chen</span>, Jingkai Lin, Runqun Xiong, Tian He, "X-MAC: Achieving High Scalability via Imperfect-Orthogonality Aware Scheduling in LPWAN",
                in Proc. of the IEEE 30th International Conference on Network Protocols.<a href="./pdf/XMAC_ICNP22.pdf" target="_blank">[PDF]</a></li>
              <li>[MobiCom'21] Ruofeng Liu, <b>Zhimeng Yin</b>, Wenchao Jiang, and Tian He, "WiBeacon: expanding BLE location-based services via wifi.",
                 in proceedings of the 27th Annual International Conference on Mobile Computing and Networking.<a href="https://dl.acm.org/doi/10.1145/3447993.3448615" target="_blank">[PDF]</a></li>
              <li>[SenSys'21] Shangyao Yan, <b>Zhimeng Yin</b>, and Guang Tang, "CurveLight:An Accurate and Practical Light Positioning System",
                 in Proc. of the 17th Conference on Embedded Network Sensor Systems.<a href="https://dl.acm.org/doi/10.1145/3485730.3485934" target="_blank">[PDF]</a></li>
              <li>[ICNP'21] <span style="text-decoration: underline;">Kai Sun</span>, <b>Zhimeng Yin</b>,  Weiwei Chen, Shuai Wang, Zeyu Zhang, and Tian He, "Partial Symbol Recovery for Interference Resilience in Low-Power Wide Area Networks",
                in Proc. of the 29th International Conference on Network Protocols.<a href="https://ieeexplore.ieee.org/document/9651936" target="_blank">[PDF]</a></li>
              <li>[ICNP'20] <span style="text-decoration: underline;">Bin Hu</span>, <b>Zhimeng Yin</b>, Shuai Wang, Zhuqing Xu, and Tian He, "SCLoRa: Leveraging Multi-Dimensionality in Decoding Collided LoRa Transmissions",
                in Proc. of the 28th International Conference on Network Protocols.<a href="https://ieeexplore.ieee.org/document/9259397" target="_blank">[PDF]</a></li>
              <li>[ICNP'20] Ruofeng Liu; <b>Zhimeng Yin</b>; Wenchao Jiang; and Tian He, "XFi: Cross-technology IoT Data Collection via Commodity WiFi",
                in Proc. of the 28th International Conference on Network Protocols.<a href="https://ieeexplore.ieee.org/document/9259363" target="_blank">[PDF]</a></li>
              <li>[ICDCS'20] <b>Zhimeng Yin</b>, Wenchao Jiang, Ruofeng Liu, Song Min Kim, and Tian He, "SafetyNet: Interference Protection via Transparent PHY Layer Coding", 
                accepted by 40th IEEE International Conference on Distributed Computing Systems.<a href="https://ieeexplore.ieee.org/document/9355809" target="_blank">[PDF]</a></li>
              <li>[INFOCOM'20] Zhuqing Xu, Junzhou Luo, <b>Zhimeng Yin</b>, Tian He, and Fang Dong, "S-MAC: Achieving High Scalability via Adaptive Scheduling in LPWAN", 
                in Proc. of the IEEE International Conference on Computer Communications.<a href="https://ieeexplore.ieee.org/document/9155474" target="_blank">[PDF]</a></li>
              <li>[INFOCOM'20] Weiwei Chen, <b>Zhimeng Yin</b> and Tian He, "Global Cooperation for Heterogeneous Networks", 
                in Proc. of the IEEE International Conference on Computer Communications.<a href="https://ieeexplore.ieee.org/document/9155453" target="_blank">[PDF]</a></li>
              <li>[SenSys'19] Ruofeng Liu, <b>Zhimeng Yin</b>, Wenchao Jiang, and Tian He, "LTE2B: Time-Domain Cross-Technology Emulation under LTE Constraints", 
                in Proc. of the 15th Conference on Embedded Network Sensor Systems.<a href="https://www.youtube.com/watch?v=ycOY9y__3bw" target="_blank">[DEMO]</a> <a href="https://drive.google.com/open?id=1YpToX-A5ObZi2xJMcViPcRtx3J21HXhi" target="_blank">[PDF]</a></li>
              <li>[ICNP'18] Shuai Wang, <b>Zhimeng Yin</b>, Zhijun Li, and Tian He, "Networking Support For Physical-Layer Cross-Technology Communication", 
                in Proc. of the 26th International Conference on Network Protocols.<a href="https://drive.google.com/open?id=10lJS-KC6DKc8JQIHiBv2gZq-RGYXZs9f" target="_blank">[PDF]</a></li>
              <li>[MobiSys'18] <b>Zhimeng Yin</b>, Zhijun Li, Song Min Kim, and Tian He, "Explicit Channel Coordination via Cross-technology Communication",
                in proceedings of 16th Annual International Conference on Mobile Systems, Applications, and Services.<a href="https://drive.google.com/open?id=1RByIdZSEoTK78UzfN8lWLzozZXDKdXTs" target="_blank">[PDF]</a></li>
              <li>[INFOCOM'17] <b>Zhimeng Yin</b>, Wenchao Jiang, Song Min Kim and Tian He, "C-Morse: Cross-technology communication with transparent Morse coding",
                in Proc. of the IEEE International Conference on Computer Communications.<a href="https://drive.google.com/open?id=1WcCAkuzyttSE6Lvp5bljeQPSM2Vjubwi" target="_blank">[PDF]</a></li>
              <li>[SenSys'17] Wenchao Jiang, <b>Zhimeng Yin</b>, Ruofeng Liu, Zhijun Li, Song Min Kim, and Tian He, "BlueBee: a 10, 000x Faster Cross-Technology Communication via PHY Emulation", 
                in Proc. of the 13th Conference on Embedded Network Sensor Systems.<a href="https://youtu.be/ZAtHBLRmEUs" target="_blank">[DEMO]</a> <a href="https://drive.google.com/open?id=1CxFDggwstEQVg81AMC-VYEF8v-X2Tanr" target="_blank">[PDF]</a></li>
              <li>[INFOCOM'17] Wenchao Jiang, <b>Zhimeng Yin</b>, Song Min Kim, and Tian He, "Transparent Cross-technology Communication over Data Traffic", 
                in Proc. of the IEEE International Conference on Computer Communications.<a href="https://drive.google.com/open?id=1cAvJAVZAXXz80_jEZkDIMsQgby4tth5h" target="_blank">[PDF]</a></li>
              <li>[ICNP'14] Shuai Wang, Song Min Kim, <b>Zhimeng Yin</b>, and Tian He,"Correlated Coding: Efficient Network Coding under Correlated Unreliable Wireless Links", 
                in Proc. of the 22nd International Conference on Network Protocols.<a href="https://drive.google.com/open?id=1Vtoev5SvDapNdgj0aG4OTU00pI2ki9UN" target="_blank">[PDF]</a></li>
              <li>[SIGMETRICS'13] Guang Tan, <b>Zhimeng Yin</b>, and Hongbo Jiang, "Trap array: a unified model for scalability evaluation of geometric routing", In ACM SIGMETRICS'13.<a href="https://drive.google.com/open?id=1rvgkNtoTgUhpQAOl6LV8cUIcuMy1xqiu" target="_blank">[PDF]</a></li>
          </ol>
        </div>
        <div class="subTitle">
          Journals
        </div>
        <div class="content">
           <ol class="c">
            <li>[TOSN] Shuai Wang, <span style="text-decoration: underline;">Luoyu Mei</span>, <b>Zhimeng Yin</b>, Hao Li, Ruofeng Liu, Wenchao Jiang, Chris Xiaoxuan Lu. "End-to-End Target Liveness Detection via mmWave Radar and Vision Fusion for Autonomous Vehicles".
              <a href="./pdf/mmLD_LivenessDetection.pdf" target="_blank">[PDF]</a></li>
            <li>[TMC] Zhuqing Xu, Junzhou Luo, <b>Zhimeng Yin</b>, Shuai Wang, <span style="text-decoration: underline;">Ciyuan Chen</span>, Jingkai Lin, Runqun Xiong, Tian He. "Leveraging Imperfect-Orthogonality Aware Scheduling for High Scalability in LPWAN".
              <a href="./pdf/IOAS_TMC.pdf" target="_blank">[PDF]</a></li>
            <li>[TMC] <span style="text-decoration: underline;">Luoyu Mei</span>, Shuai Wang, Ruofeng Liu, Yun Cheng, Wenchao Jiang, <b>Zhimeng Yin</b>, Tian He. "VR-PCT: Enhanced VR Semantic Performance via Edge-Client Collaborative Multi-modal Point Cloud Transformers".
              <a href="./pdf/VRPCT_TMC.pdf" target="_blank">[PDF]</a></li>
            <li>[TMC] <span style="text-decoration: underline;">Xiubin Fan</span>, Zhongming Lin, Yuming Hu, Zhiqing Hong, Tianrui Jiang, Feng Qian, <b>Zhimeng Yin</b>, S-H Gary Chan, Dapeng Oliver Wu. "DeMo: Experiences of Deploying a Large-Scale Indoor Delivery Monitoring System".
              <a href="./pdf/DeMo_TMC.pdf" target="_blank">[PDF]</a></li>
            <li>[TMC] <span style="text-decoration: underline;">Weizheng Wang</span>, Dusit Niyato, Zehui Xiong, <b>Zhimeng Yin</b>. "AUTHFi: Cross-technology device authentication via commodity WiFi".
              <a href="./pdf/AUTHFi_TMC.pdf" target="_blank">[PDF]</a></li>
            <li>[TMC] Yuhan Lin, Haoran Xu, <b>Zhimeng Yin</b>, Guang Tan. "Edge assisted low-latency cooperative BEV perception with progressive state estimation".
              <a href="https://ieeexplore.ieee.org/abstract/document/10772318" target="_blank">[PDF]</a></li>
            <li>[TOSN] <span style="text-decoration: underline;">Qiling Xu</span>, <span style="text-decoration: underline;">Danei Gong</span>, <span style="text-decoration: underline;">Kai Sun</span>, Shuai Wang, Pengpeng Chen, Binbin Xie, <b>Zhimeng Yin</b>. "SLoRa+: A Systematic Framework for Enhanced Interference Resilience in LoRaWAN".
              <a href="./pdf/SLoRaPlus_TOSN.pdf" target="_blank">[PDF]</a></li>
            <li>[CN] <span style="text-decoration: underline;">Kai Sun</span>, <span style="text-decoration: underline;">Bin Hu</span>, <b>Zhimeng Yin</b>, Shuai Wang, Zhuqing Xu, Tian He. "Joint multidimensional features for LoRa reception in burst traffic".
              <a href="https://www.sciencedirect.com/science/article/pii/S1389128625004438" target="_blank">[PDF]</a></li>
            <li>[TMC] <span style="text-decoration: underline;">Naiyu Zheng</span>, Yuanchun Li, Shiqi Jiang, Yuanzhe Li, Rongchun Yao, Chuchu Dong, Ting Chen, Yubo Yang, <b>Zhimeng Yin</b>, Yunxin Liu, "AdaWiFi, Collaborative WiFi Sensing for Cross-Environment Adaptation", 
                in IEEE Transactions on Mobile Computing.<a href="https://ieeexplore.ieee.org/abstract/document/10715589/" target="_blank">[PDF]</a></li>
            <li>[CN] <span style="text-decoration: underline;">Ciyuan Chen</span>, Junzhou Luo, Zhuqing Xu, Runqun Xiong, Dian Shen, <b>Zhimeng Yin</b>, "Enabling large-scale low-power LoRa data transmission via multiple mobile LoRa gateways", 
                in Computer Networks.<a href="https://www.sciencedirect.com/science/article/pii/S1389128623005285" target="_blank">[PDF]</a></li>
              <li>[CEM] <span style="text-decoration: underline;">Weizheng Wang</span>, Fida Hussain Memon, Zhuotao Lian, <b>Zhimeng Yin</b>, Thippa Reddy Gadekallu, Quoc-Viet Pham, Kapal Dev, Chunhua Su, "Secure-Enhanced Federated Learning for AI-Empowered Electric Vehicle Energy Prediction", 
                in IEEE Consumer Electronics Magazine.<a href="https://ieeexplore.ieee.org/abstract/document/9555212" target="_blank">[PDF]</a></li>
              <li>[DCN] <span style="text-decoration: underline;">Weizheng Wang</span>, Huakun Huang, <b>Zhimeng Yin</b>, Thippa Reddy Gadekallu, Mamoun Alazab, Chunhua Su, "Smart contract token-based privacy-preserving access control system for industrial Internet of Things", 
                in Digital Communications and Networks.<a href="https://www.sciencedirect.com/science/article/pii/S2352864822002140" target="_blank">[PDF]</a></li>
              <li>[JSAC] <span style="text-decoration: underline;">Weizheng Wang</span>, Yaoqi Yang, <b>Zhimeng Yin</b>, Kapal Dev, Xiaokang Zhou, Xingwang Li, Nawab Muhammad Faseeh Qureshi, Chunhua Su, "BSIF: Blockchain-Based Secure, Interactive, and Fair Mobile Crowdsensing", 
                in IEEE Journal on Selected Areas in Communications.<a href="https://ieeexplore.ieee.org/abstract/document/9921212" target="_blank">[PDF]</a></li>
              <li>[IOT] <span style="text-decoration: underline;">Weizheng Wang</span>, Qiu Chen, <b>Zhimeng Yin</b>, Gautam Srivastava, Thippa Reddy Gadekallu, Fawaz Alsolami, Chunhua Su, "Blockchain and PUF-based lightweight authentication protocol for wireless medical sensor networks", 
                in IEEE Internet of Things Journal.<a href="https://ieeexplore.ieee.org/abstract/document/9559388" target="_blank">[PDF]</a></li>  
              <li>[TMC] Shuai Wang, <b>Zhimeng Yin</b>, Shuai Wang, Yongrui Chen, Zhijun Li, Song Min Kim, and Tian He, "Networking Support for Bidirectional Cross-technology Communication", 
                in the ACM Transactions on Mobile Computing.<a href="https://drive.google.com/open?id=1ZNxFwbUvGzFn3xNLFDEWsYF9BcpDGFNl" target="_blank">[PDF]</a></li>
              <li>[TON] Wenchao Jiang,<b> Zhimeng Yin</b>, Ruofeng Liu, Zhijun Li, Song Min Kim, and Tian He, "Boosting the Bitrate of Cross-Technology Communication on Commodity IoT Devices", 
                in the ACM/IEEE Transactions on Networking.<a href="https://drive.google.com/open?id=1oK5KF09qTre71BMFi_WtyifMXGKtzR0S" target="_blank">[PDF]</a></li>
              <li>[TON] Guang Tan, <b>Zhimeng Yin</b>, and Hongbo Jiang, "Trap Array: A Unified Model for Scalability Evaluation of Geometric Routing", 
                in the ACM/IEEE Transactions on Networking.<a href="https://drive.google.com/open?id=1L21ERP-1EgakU3GRfhPODdBbBVM3P7gz" target="_blank">[PDF]</a></li>
              <li>[TWC] Kechao Cai, <b>Zhimeng Yin</b>, Hongbo Jiang, Guang Tan, Peng Guo, Chonggang Wang, and Bo Li, "OnionMap: A Scalable Geometric Addressing and Routing Scheme for 3D Sensor Networks", 
                In IEEE Transactions on Wireless Communications.<a href="https://drive.google.com/open?id=1rfbfLE-o0wfsja_Q3kvWRr1p-hzaxT0D" target="_blank">[PDF]</a></li>
              <li>[TOSN] Shuai Wang, Song Min Kim, <b>Zhimeng Yin</b>, and Tian He, "Encode When Necessary: Correlated Network Coding Under Unreliable Wireless Links," 
                in the ACM Transactions on Sensor Networks.<a href="https://drive.google.com/open?id=1YciMa0ELFkdsV0kQLuUHVkZY0Z3oNwrb" target="_blank">[PDF]</a></li>
              <li>[TOSN] Guang Tan, Hongbo Jiang, Shengkai Zhang, <b>Zhimeng Yin</b>, Anne-Marie Kermarrec, "Connectivity-based and anchor-free localization in large-scale 2D/3D sensor networks", 
                in the ACM Transactions on Sensor Networks.<a href="https://drive.google.com/open?id=1QYTNNLqACyZDWgiJYCP0hC9beB1OVvcF" target="_blank">[PDF]</a></li>
          </ol> 
        </div>
      </div>

      <!-- Alumni 大栏（小屏） -->
      <div class="alumni">
        <div class="head2">Alumni</div>
        <ul class="a">
          <li>
            <a href="https://staff.uic.edu.cn/xiubinfan/en" target="_blank">Dr. Xiubin Fan</a>
            (PhD Student, Sep 2021–Jun 2025), Assistant Professor at Beijing Normal–Hong Kong Baptist University.
          </li>
          <li>
            <span>Dr. Weizheng Wang</span>
            (PhD Student, Sep 2021–Apr 2025), Professor at Guangzhou University.
          </li>
        </ul>
      </div>

      <div class="demo">
        <div class="head2">BlueBee Demo</div>
        <div class="show">
           <div class="vedios">
                <iframe width="562" height="316" 
                src="https://www.youtube.com/embed/ZAtHBLRmEUs" frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen></iframe>
           </div>
           <div class="description">
              The cross-technology communication (CTC) is a promising technique proposed recently to bridge heterogeneous wireless technologies in the ISM bands. 
              Existing solutions use only the coarse-grained packet-level information for CTC modulation, suffering from a low throughput (e.g., 10 b/s). 
              BlueBee explores the PHY-layer information for CTC by emulating legitimate ZigBee frames with the Bluetooth radio, achieving dual-standard compliance and transparency. 
              Our implementation on both USRP and commodity devices shows that BlueBee can achieve standard ZigBee bit rate of 250 kb/s at more than 99% accuracy, 
              10000x faster than the start-of-the-art packet-level CTC technologies. 
           </div>
        </div>
        <div class="head2">LTE2B Demo</div>
        <div class="show">
          <div class="vedios">
                <iframe width="562" height="316" 
                src="https://www.youtube.com/embed/ycOY9y__3bw" frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen></iframe>
           </div>
           <div class="description">
              LTE2B enables WAN/WLAN devices, e.g., LTE smartphones and WiFi Access Points, 
              to directly transmit data to low-power IoT devices such as ZigBee and Bluetooth. 
              This is achieved via Time-domain Emulation that enables WAN/WLAN transmitters to accurately emulate the ZigBee/Bluetooth waveform. 
              We implement LTE2B on commodity devices (Nexus 5X smartphone and CC2530/CC1350 ZigBee/BLE SoC). 
              Extensive evaluation demonstrates that LTE2B achieves a robust (> 99% accuracy) and long distance (> 400 m) CTC performance under a full range of wireless configurations including indoor/outdoor, mobility, and duty-cycle settings. 
           </div>
        </div>
      </div>
      <div class="acitivities">
        <div class="head2">Professional Acitivities</div>
        <div class="subTitle">
          Journal Editors and Conference Organization Committee
        </div>
        <div class="content">
          <ul class="c">
            <li>ACM Transactions on Internet of Things, Associate Editor.</li>
            <li>IEEE Wireless Communications Letters, Associate Editor.</li>
            <li>ACM MobiSys 2025, Student Travel Grant Chair.</li>
            <li>IEEE ICPADS 2021, Publication Chair.</li>
          </ul>
        </div>
        <div class="subTitle">
          Recent TPC activities
        </div>
        <div class="content">
          <ul class="c">
            <li>SenSys 2026&amp;2027</li>
            <li>MobiCom 2027</li>
            <li>MSN 2025</li>
            <li>ICDCS 2025&amp;2021</li>
            <li>BuildSys 2025</li>
            <li>EWSN 2025</li>
            <li>IMWUT 2025&amp;2024</li>
            <li>VTC 2024</li>
            <li>IoTDI 2024</li>
            <li>HPCC 2024</li>
            <li>VTC 2024&amp;2023</li>
            <li>Smart City 2022</li>
          </ul>
        </div>
        <div class="subTitle">
          Reviewer
        </div>
        <div class="content">
          <ul class="c">
            <li>IEEE/ACM Transactions on Networking</li>
            <li>IEEE Transactions on Mobile Computing</li>
            <li>ACM Transactions on Sensor Networks</li>
            <li>ACM Transactions on Internet of Things</li>
            <li>IEEE Journal on Selected Areas in Communications</li>
            <li>Computer Networks</li>
            <li>IEEE Journal on Selected Areas in Communications</li>
          </ul>
        </div>
        </div>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      screenWidth:''// Monitoring the width and when it is less than 1150px, the site would be reloaded.
    };
  },
  mounted(){
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
    }
  }
}
</script>

<style>
/* #app{
  padding: 0;
  margin:0 ;
} */
/* body{
  background-size: 100%;
} */
.bar{
  position: fixed;
  top: 0px;
  left: 0px;
  display: flex;
  flex-direction: row;
  width: 100%;
}
.icon{
  display: flex;
  width: 180px;
  color: aliceblue;
  background-color:rgb(4, 25, 83);
  padding-top: 10px;
  padding-bottom: 10px;
  display:inline;
  font-size: 25px;
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
}
.else{
  display: flex;
  background-color: rgb(5, 73, 122);
  width: calc(100% - 180px);
  /* margin-right: 0px; */
}
.other{
  display:flex;
  width:1150px;
  padding-top: 105px;
  flex-direction: column;
  margin:0 auto;
  /* background-color: antiquewhite; */
}
.otherSmall{
  display:flex;
  width:100%;
  padding-top: 105px;
  flex-direction: column;
  margin:0 auto;
}
.basic{
  display: flex;
  flex-direction: row;
}
.info{
  width: 70%;
}
.photo{
  /* background-color: aquamarine; */
  width: 30%;
}
img{
  width: 50%;
  margin-left: 30%;
  margin-top: 5%;
}
.head{
  color:rgb(8, 53, 177);
  font-size:25px ;
  padding-bottom: 18px;
}
.head2{
  color:rgb(8, 53, 177);
  font-size:25px ;
  padding-bottom: 7px;
}
.interests{
  margin-top: 45px;
}
.recruiting{
  margin-top: 45px;
}
ul.a{
  list-style-type:square;
  margin-top: 0px;
  padding-left: 18px;
  font-size: 14px;
  line-height: 25px;
  padding-bottom: 10px;
}
ul.b{
  list-style-type:none;
  margin-top: 0px;
  padding-left: 18px;
  font-size: 14px;
  line-height: 25px;
}
.cv{
  margin-top: 45px;
}
.cvInfo{
  display: flex;
  flex-direction: row;
}
.left{
  width: 70%;
  /* background-color: aquamarine; */
}
.publications{
  margin-top: 45px;
}
.awards{
  margin-top: 45px;
}
.alumni{
  margin-top: 45px;
}
.acitivities{
  margin-top: 45px;
}
.subTitle{
  font-size: 20px;
  padding-top: 3px;
}
ol.c{
  margin-top: 0px;
  padding-left: 26px;
  font-size: 14px;
  line-height: 25px;
}
.demo{
  margin-top: 45px;
}
.show{
  margin-bottom: 45px;
  display: flex;
  flex-direction: row;
}
.vedios{
  display: flex;
  width: 50%;
  /* background-color: brown; */
}
.description{
  display: flex;
  margin-top: 15px;
  margin-left: 15px;
  /* background-color: cadetblue; */
  width: 50%;
}
.bottom{
  margin-bottom: 60px;
  display: flex;
  flex-direction: row;
}
a:link {color:rgb(8, 53, 177);}      /* 未访问链接*/
a:visited {color:rgb(8, 53, 177);}  /* 已访问链接 */
a:hover {color:rgb(8, 53, 177);}  /* 鼠标移动到链接上 */
a:active {color:rgb(8, 53, 177);}  /* 鼠标点击时 */
</style>